module.exports = __webpack_public_path__ + "static/media/96.93015195.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/96.jpg
// module id = 1028
// module chunks = 0